/**
 * Jul-2026 (User-Wunsch) — Logo der Leasinggesellschaft als Badge in den
 * Auflistungen der Leasingrückläufer (Santander rot, CA Auto Bank dunkel).
 * Fällt auf einen Klartext-Badge zurück, wenn kein Logo hinterlegt ist.
 */
const SANTANDER_LOGO = "https://customer-assets.emergentagent.com/job_0dd57546-d87a-4168-8fcb-86dfdac2e5b0/artifacts/cy8nhh8t_santander_logo_large_red.svg";
const CA_AUTO_BANK_LOGO = "https://customer-assets.emergentagent.com/job_0dd57546-d87a-4168-8fcb-86dfdac2e5b0/artifacts/p3trhezi_LOGO-CA-AUTO-BANK_696x696.png";
const RENAULT_BANK_LOGO = "https://static.prod-images.emergentagent.com/jobs/c6afdf58-6d43-43b5-ad22-ee66901c33c9/images/087dea056912c0d8f7ed61a6baa0b40d4799133555ccc895d322c876d59ccc72.jpeg";

export function bankLogoFor(name) {
    const lc = (name || "").trim().toLowerCase();
    if (!lc) return null;
    if (lc.includes("santander")) return { src: SANTANDER_LOGO, alt: "Santander", dark: false };
    if (lc.includes("renault")) return { src: RENAULT_BANK_LOGO, alt: "Renault Bank", dark: true };
    if (lc.includes("auto bank") || lc.includes("credit agric") || lc.startsWith("ca ") || lc.startsWith("ca-") || lc.startsWith("ca")) {
        return { src: CA_AUTO_BANK_LOGO, alt: "CA Auto Bank", dark: true };
    }
    return null;
}

export default function BankLogoBadge({ company, size = "sm", testid }) {
    const logo = bankLogoFor(company);
    if (!logo) {
        return company
            ? <span className="text-[10px] uppercase font-bold px-1.5 py-0.5 rounded-sm bg-gray-100 text-gray-700 shrink-0" data-testid={testid}>{company}</span>
            : null;
    }
    const h = size === "lg" ? "h-6" : "h-4";
    return (
        <span
            className={`inline-flex items-center shrink-0 rounded-sm px-1.5 py-0.5 border ${logo.dark ? "bg-black border-gray-800" : "bg-white border-gray-200"}`}
            title={company || logo.alt}
            data-testid={testid}
        >
            <img src={logo.src} alt={logo.alt} className={`${h} w-auto`} />
        </span>
    );
}
